import angular from 'angular';
import EditComponent from './components/manage-login-sms-notification-edit/component';
import ViewComponent from './components/manage-login-sms-notification-view/component';

export default angular
  .module('manage-login-sms-notifications', [])
  .component('manageLoginSmsNotificationEdit', new EditComponent())
  .component('manageLoginSmsNotificationView', new ViewComponent());



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-login-sms-notification/manage-login-sms-notification-component.js